module.exports = __webpack_public_path__ + "./fonts/GothamRnd-Bold.otf";